import merge from 'lodash/merge.js';

import Item from '@/store/quill/Item.js';

export default merge(
    Item({
        dates: ['created_at', 'updated_at'],
    }),
    {
        autoImport: false,

        state() {
            return {
                active_student_count: null,
                basic_description: null,
                course_settings: null,
                course_type_id: null,
                created_at: null,
                description: null,
                enrollment_capacity: null,
                gradebook: null,
                grading_scheme_id: null,
                grading_scheme: null,
                groups: [],
                id: null,
                in_progress: null,
                is_accessible: null,
                is_accessible_to_students: null,
                is_active: null,
                completed: null,
                is_archived: null,
                instructors: null,
                order: null,
                items: null,
                tags: [],
                title: null,
                has_gradable_activity: null,
                has_course_grades: null,
                has_activity_with_conflicting_minimum_passing_score: null,
                updated_at: null,
                statuses: null,
                students: [],
                attendances_count: null,
                course_codes: null,
                course_key_id: null,
            };
        },

        getters: {},

        actions: {
            /**
             * @param context
             * @param payload
             * @returns {Promise<any>}
             */
            put(context, payload) {
                return new Promise((resolve, reject) => {
                    window.axios
                        .put(`/api/course/${context.state.id}`, payload)
                        .then(response => {
                            context.dispatch('Course/add', response.data.data, {
                                root: true,
                            });

                            resolve(response);
                        })
                        .catch(error => {
                            context.dispatch(
                                'Alerts/add',
                                {
                                    key: 'course_template_saving_error',
                                    title: 'An Error Has Occurred',
                                    message: 'This course template has failed to save',
                                    type: 'danger',
                                },
                                { root: true }
                            );

                            reject(error);
                        });
                });
            },
        },

        mutations: {
            EDIT: (state, { property, value }) => (state[property] = value),
        },
    }
);
